import React, { useState } from "react";
//MaterialUI
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { addProduct } from "../redux/slices/product/productSlice";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    Width: "100%",
  },
}));

export default function ProductAdd() {
  const initialFormData = Object.freeze({
    name: "",
    number: "",
    status: "active",
    description: "",
  });

  const [formData, updateFormData] = useState(initialFormData);

  const handleChange = (e) => {
    setStatus(e.target.value);
    updateFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addProduct(formData));
  };

  const classes = useStyles();

  const [status, setStatus] = React.useState();

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}> </div>
      <Container maxWidth="sm">
        <form>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="name"
            label="Name"
            name="name"
            autoComplete="name"
            autoFocus
            onChange={handleChange}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="number"
            label="Number"
            name="number"
            autoComplete="number"
            autoFocus
            onChange={handleChange}
          />

          <FormControl
            variant="outlined"
            required
            fullWidth
            margin="normal"
            id="status"
            className={classes.formControl}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              Status
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              onChange={handleChange}
              value={status}
              label="Status"
              name="status"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={"active"}>Active</MenuItem>
              <MenuItem value={"discontinued"}>Discontinued</MenuItem>
              <MenuItem value={"phase out"}>Phase out</MenuItem>
            </Select>
          </FormControl>

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="description"
            label="description"
            type="description"
            id="description"
            autoComplete="current-description"
            onChange={handleChange}
          />
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            endIcon={<Icon>send</Icon>}
            onClick={handleSubmit}
          >
            Create new product
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            startIcon={<DeleteIcon />}
          >
            Cancel
          </Button>
        </form>
      </Container>
    </Container>
  );
}
